.notice {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 10px 0;
    padding: 10px 14px;
    border-left: 5px solid #c62828;
    background-color: #fdecec;
    color: #7f1d1d;
    font-size: 13px;
    line-height: 1.5;
}

.icon {
    flex: none;
    width: 20px;
    height: 20px;
    color: #c62828;
}

.text {
    margin: 0;
}
